<ml-device-name-ui (deviceName)="deviceName($event)"></ml-device-name-ui>